// App.jsx
import React, { useState, useEffect } from 'react';
import './App.css';
//import ApplicationForm from './components/ApplicationForm';
import PaymentModal from './PaymentModal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function SApp() {
  const [formData, setFormData] = useState({
    // Applicant Details
    applicantName: '',
    applicantMobile: '',
    applicantEmail: '',
    applicantAddress: '',
    
    // Property Details
    division: '',
    district: '',
    taluka: '',
    village: '',
    area: '',
    surveyNumber: '',
    PropertyNumberType: '',
    villagePart: '',
    
    // Regional Plan Details
    regional_plan_name: '',
    regional_plan_approval_notification_number: '',
    regional_plan_approval_date: '',
    implementation_date: '',
    
    // Questions
    question1: '',
    question2: '',
    question3: '',
    
    // Confirmations
    confirm1: false,
    confirm2: false,
    confirm_payment: false,
    
    // Payment Details
    paymentMethod: 'offline',
    utrChequeNo: '',
    
    // Files
    attachment: null,
    attachmentMeasurement: null,
    paymentReceipt: null,
    upload_certificate: null,
    attachment_pr_satbara: null,
    attachment_MeasurementSheet: null,
    
    // Other
    certification_name: '',
    status: 'pending'
  });

  const [divisions, setDivisions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [villages, setVillages] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState('');
  const [authToken, setAuthToken] = useState(localStorage.getItem('token') || '');
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 3;

  // Load initial data
  useEffect(() => {
    loadDivisionCodes();
    // Load token from storage or login
    if (!authToken) {
      // In real app, you would redirect to login
      // For demo, we'll simulate login
      simulateLogin();
    }
  }, []);

  const simulateLogin = async () => {
    // This should be replaced with actual login API
    const mockToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiYXBwbF81NjQ4MjkxIiwidXNlcl90eXBlIjoiYXBwbGljYW50IiwiZXhwIjoxNzQxMjM0NTYwfQ.mock-token-for-demo";
    localStorage.setItem('token', mockToken);
    setAuthToken(mockToken);
  };

  const loadDivisionCodes = async () => {
    try {
      const response = await fetch('/api/division_codes.json');
      const data = await response.json();
      setDivisions(Object.keys(data));
    } catch (error) {
      console.error('Error loading divisions:', error);
      toast.error('Failed to load divisions');
    }
  };

  const loadDistrictCodes = async (division) => {
    try {
      const response = await fetch('/api/district_codes.json');
      const data = await response.json();
      const filteredDistricts = Object.keys(data).filter(district => 
        district.startsWith(division.slice(0, 2)) // Adjust based on your data structure
      );
      setDistricts(filteredDistricts);
    } catch (error) {
      console.error('Error loading districts:', error);
      toast.error('Failed to load districts');
    }
  };

  const loadTalukas = async (district) => {
    try {
      const response = await fetch('/api/receiver_mapping.json');
      const data = await response.json();
      const uniqueTalukas = [...new Set(data
        .filter(item => item.district === district)
        .map(item => item.taluka)
      )];
      setTalukas(uniqueTalukas);
    } catch (error) {
      console.error('Error loading talukas:', error);
      toast.error('Failed to load talukas');
    }
  };

  const loadVillages = async (taluka) => {
    // This would come from your API
    const mockVillages = ['Village A', 'Village B', 'Village C'];
    setVillages(mockVillages);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    
    if (type === 'checkbox') {
      setFormData(prev => ({
        ...prev,
        [name]: checked
      }));
    } else if (type === 'file') {
      setFormData(prev => ({
        ...prev,
        [name]: files[0]
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));

      // Handle cascading dropdowns
      if (name === 'division') {
        loadDistrictCodes(value);
        setFormData(prev => ({ ...prev, district: '', taluka: '', village: '' }));
      } else if (name === 'district') {
        loadTalukas(value);
        setFormData(prev => ({ ...prev, taluka: '', village: '' }));
      } else if (name === 'taluka') {
        loadVillages(value);
        setFormData(prev => ({ ...prev, village: '' }));
      }
    }
  };

  const validateForm = () => {
    const errors = [];

    // Basic validation
    if (!formData.applicantName.trim()) errors.push('Applicant name is required');
    if (!formData.applicantMobile.match(/^\d{10}$/)) errors.push('Valid 10-digit mobile number is required');
    if (!formData.applicantEmail.includes('@')) errors.push('Valid email is required');
    if (!formData.division) errors.push('Division is required');
    if (!formData.district) errors.push('District is required');
    if (!formData.taluka) errors.push('Taluka is required');
    if (!formData.village) errors.push('Village is required');
    if (!formData.surveyNumber) errors.push('Survey number is required');
    if (!formData.area) errors.push('Area is required');
    
    if (!formData.confirm1) errors.push('You must confirm declaration 1');
    if (!formData.confirm2) errors.push('You must confirm declaration 2');
    
    if (formData.paymentMethod === 'offline' && !formData.utrChequeNo) {
      errors.push('UTR/Cheque number is required for offline payment');
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const errors = validateForm();
    if (errors.length > 0) {
      errors.forEach(error => toast.error(error));
      return;
    }

    setIsSubmitting(true);

    const formDataToSend = new FormData();
    
    // Append all form data
    Object.keys(formData).forEach(key => {
      if (formData[key] !== null && formData[key] !== undefined) {
        if (key.includes('attachment') || key.includes('Receipt') || key.includes('certificate')) {
          if (formData[key]) {
            formDataToSend.append(key, formData[key]);
          }
        } else if (key === 'confirm1' || key === 'confirm2' || key === 'confirm_payment') {
          formDataToSend.append(key, formData[key] ? '1' : '0');
        } else {
          formDataToSend.append(key, formData[key]);
        }
      }
    });

    try {
      const response = await fetch('/api/submit_request.php', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${authToken}`
        },
        body: formDataToSend
      });

      const result = await response.json();

      if (result.status === 'success') {
        toast.success('Application submitted successfully!');
        
        if (formData.paymentMethod === 'online') {
          // Generate payment URL and show modal
          const paymentUrl = generatePaymentUrl(result.request_unique_id);
          setPaymentUrl(paymentUrl);
          setShowPaymentModal(true);
        } else {
          // For offline payment, just show success
          toast.info('Please complete offline payment process');
        }
        
        // Reset form after successful submission
        setCurrentStep(1);
        setFormData({
          applicantName: '',
          applicantMobile: '',
          applicantEmail: '',
          applicantAddress: '',
          division: '',
          district: '',
          taluka: '',
          village: '',
          area: '',
          surveyNumber: '',
          PropertyNumberType: '',
          villagePart: '',
          regional_plan_name: '',
          regional_plan_approval_notification_number: '',
          regional_plan_approval_date: '',
          implementation_date: '',
          question1: '',
          question2: '',
          question3: '',
          confirm1: false,
          confirm2: false,
          confirm_payment: false,
          paymentMethod: 'offline',
          utrChequeNo: '',
          attachment: null,
          attachmentMeasurement: null,
          paymentReceipt: null,
          upload_certificate: null,
          attachment_pr_satbara: null,
          attachment_MeasurementSheet: null,
          certification_name: '',
          status: 'pending'
        });
      } else {
        toast.error(`Submission failed: ${result.message}`);
      }
    } catch (error) {
      toast.error(`Network error: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const generatePaymentUrl = (requestId) => {
    // This would be your actual payment gateway URL
    const merchantId = "M_maha1122_1234";
    const amount = "100.00"; // Example amount
    const currency = "INR";
    
    return `/api/ccavRequestHandler.php?merchant_id=${merchantId}&amount=${amount}&currency=${currency}&request_id=${requestId}`;
  };

  const handlePaymentSuccess = (paymentData) => {
    setShowPaymentModal(false);
    toast.success(`Payment successful! Tracking ID: ${paymentData.tracking_id}`);
  };

  const handlePaymentError = (error) => {
    setShowPaymentModal(false);
    toast.error(`Payment failed: ${error}`);
  };

  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
      window.scrollTo(0, 0);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      window.scrollTo(0, 0);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Land Record Application</h1>
        <p>Complete the form below to submit your application</p>
      </header>

      <div className="progress-bar">
        {[...Array(totalSteps)].map((_, index) => (
          <div 
            key={index} 
            className={`progress-step ${index + 1 <= currentStep ? 'active' : ''}`}
          >
            <div className="step-number">{index + 1}</div>
            <div className="step-label">
              {index === 0 && 'Applicant Details'}
              {index === 1 && 'Property Details'}
              {index === 2 && 'Documents & Payment'}
            </div>
          </div>
        ))}
      </div>

      <form onSubmit={handleSubmit} className="application-form">
        {currentStep === 1 && (
          <div className="form-step">
            <h2>Applicant Details</h2>
            <div className="form-group">
              <label htmlFor="applicantName">Full Name *</label>
              <input
                type="text"
                id="applicantName"
                name="applicantName"
                value={formData.applicantName}
                onChange={handleInputChange}
                required
                placeholder="Enter your full name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="applicantMobile">Mobile Number *</label>
              <input
                type="tel"
                id="applicantMobile"
                name="applicantMobile"
                value={formData.applicantMobile}
                onChange={handleInputChange}
                required
                pattern="[0-9]{10}"
                placeholder="10-digit mobile number"
              />
            </div>

            <div className="form-group">
              <label htmlFor="applicantEmail">Email Address *</label>
              <input
                type="email"
                id="applicantEmail"
                name="applicantEmail"
                value={formData.applicantEmail}
                onChange={handleInputChange}
                required
                placeholder="Enter your email"
              />
            </div>

            <div className="form-group">
              <label htmlFor="applicantAddress">Address *</label>
              <textarea
                id="applicantAddress"
                name="applicantAddress"
                value={formData.applicantAddress}
                onChange={handleInputChange}
                required
                rows="3"
                placeholder="Enter your complete address"
              />
            </div>

            <button type="button" className="btn-next" onClick={nextStep}>
              Next: Property Details →
            </button>
          </div>
        )}

        {currentStep === 2 && (
          <div className="form-step">
            <h2>Property Details</h2>
            
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="division">Division *</label>
                <select
                  id="division"
                  name="division"
                  value={formData.division}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Division</option>
                  {divisions.map(division => (
                    <option key={division} value={division}>{division}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="district">District *</label>
                <select
                  id="district"
                  name="district"
                  value={formData.district}
                  onChange={handleInputChange}
                  required
                  disabled={!formData.division}
                >
                  <option value="">Select District</option>
                  {districts.map(district => (
                    <option key={district} value={district}>{district}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="taluka">Taluka *</label>
                <select
                  id="taluka"
                  name="taluka"
                  value={formData.taluka}
                  onChange={handleInputChange}
                  required
                  disabled={!formData.district}
                >
                  <option value="">Select Taluka</option>
                  {talukas.map(taluka => (
                    <option key={taluka} value={taluka}>{taluka}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="village">Village *</label>
                <select
                  id="village"
                  name="village"
                  value={formData.village}
                  onChange={handleInputChange}
                  required
                  disabled={!formData.taluka}
                >
                  <option value="">Select Village</option>
                  {villages.map(village => (
                    <option key={village} value={village}>{village}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="surveyNumber">Survey Number *</label>
                <input
                  type="text"
                  id="surveyNumber"
                  name="surveyNumber"
                  value={formData.surveyNumber}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter survey number"
                />
              </div>

              <div className="form-group">
                <label htmlFor="area">Area (in sq meters) *</label>
                <input
                  type="number"
                  id="area"
                  name="area"
                  value={formData.area}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter area"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="PropertyNumberType">Property Number Type</label>
                <select
                  id="PropertyNumberType"
                  name="PropertyNumberType"
                  value={formData.PropertyNumberType}
                  onChange={handleInputChange}
                >
                  <option value="">Select Type</option>
                  <option value="New">New</option>
                  <option value="Old">Old</option>
                  <option value="Both">Both</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="villagePart">Village Part</label>
                <input
                  type="text"
                  id="villagePart"
                  name="villagePart"
                  value={formData.villagePart}
                  onChange={handleInputChange}
                  placeholder="Enter village part"
                />
              </div>
            </div>

            <div className="navigation-buttons">
              <button type="button" className="btn-prev" onClick={prevStep}>
                ← Previous
              </button>
              <button type="button" className="btn-next" onClick={nextStep}>
                Next: Documents & Payment →
              </button>
            </div>
          </div>
        )}

        {currentStep === 3 && (
          <div className="form-step">
            <h2>Documents & Payment</h2>
            
            <div className="file-upload-section">
              <h3>Required Documents</h3>
              
              <div className="form-group">
                <label htmlFor="attachment">Satbara/7-12 Document *</label>
                <input
                  type="file"
                  id="attachment"
                  name="attachment"
                  onChange={handleInputChange}
                  accept=".pdf,.jpg,.jpeg,.png"
                  required
                />
                <small>Accepted formats: PDF, JPG, PNG</small>
              </div>

              <div className="form-group">
                <label htmlFor="attachmentMeasurement">Measurement Document *</label>
                <input
                  type="file"
                  id="attachmentMeasurement"
                  name="attachmentMeasurement"
                  onChange={handleInputChange}
                  accept=".pdf,.jpg,.jpeg,.png"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="attachment_pr_satbara">Property Registration/Satbara</label>
                <input
                  type="file"
                  id="attachment_pr_satbara"
                  name="attachment_pr_satbara"
                  onChange={handleInputChange}
                  accept=".pdf,.jpg,.jpeg,.png"
                />
              </div>

              <div className="form-group">
                <label htmlFor="attachment_MeasurementSheet">Measurement Sheet</label>
                <input
                  type="file"
                  id="attachment_MeasurementSheet"
                  name="attachment_MeasurementSheet"
                  onChange={handleInputChange}
                  accept=".pdf,.jpg,.jpeg,.png"
                />
              </div>

              <div className="form-group">
                <label htmlFor="upload_certificate">Certificate (if any)</label>
                <input
                  type="file"
                  id="upload_certificate"
                  name="upload_certificate"
                  onChange={handleInputChange}
                  accept=".pdf,.jpg,.jpeg,.png"
                />
              </div>
            </div>

            <div className="payment-section">
              <h3>Payment Details</h3>
              
              <div className="form-group">
                <label>Payment Method *</label>
                <div className="radio-group">
                  <label>
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="offline"
                      checked={formData.paymentMethod === 'offline'}
                      onChange={handleInputChange}
                    />
                    Offline (Bank/Cheque)
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="online"
                      checked={formData.paymentMethod === 'online'}
                      onChange={handleInputChange}
                    />
                    Online Payment
                  </label>
                </div>
              </div>

              {formData.paymentMethod === 'offline' && (
                <div className="form-group">
                  <label htmlFor="utrChequeNo">UTR/Cheque Number *</label>
                  <input
                    type="text"
                    id="utrChequeNo"
                    name="utrChequeNo"
                    value={formData.utrChequeNo}
                    onChange={handleInputChange}
                    required={formData.paymentMethod === 'offline'}
                    placeholder="Enter UTR or Cheque number"
                  />
                </div>
              )}

              {formData.paymentMethod === 'offline' && (
                <div className="form-group">
                  <label htmlFor="paymentReceipt">Payment Receipt</label>
                  <input
                    type="file"
                    id="paymentReceipt"
                    name="paymentReceipt"
                    onChange={handleInputChange}
                    accept=".pdf,.jpg,.jpeg,.png"
                  />
                </div>
              )}
            </div>

            <div className="declarations-section">
              <h3>Declarations</h3>
              
              <div className="checkbox-group">
                <label>
                  <input
                    type="checkbox"
                    name="confirm1"
                    checked={formData.confirm1}
                    onChange={handleInputChange}
                    required
                  />
                  I declare that the information provided is true and correct to the best of my knowledge.
                </label>
              </div>

              <div className="checkbox-group">
                <label>
                  <input
                    type="checkbox"
                    name="confirm2"
                    checked={formData.confirm2}
                    onChange={handleInputChange}
                    required
                  />
                  I agree to the terms and conditions of the application process.
                </label>
              </div>

              <div className="checkbox-group">
                <label>
                  <input
                    type="checkbox"
                    name="confirm_payment"
                    checked={formData.confirm_payment}
                    onChange={handleInputChange}
                  />
                  I confirm the payment details are correct.
                </label>
              </div>
            </div>

            <div className="navigation-buttons">
              <button type="button" className="btn-prev" onClick={prevStep}>
                ← Previous
              </button>
              <button 
                type="submit" 
                className="btn-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Application'}
              </button>
            </div>
          </div>
        )}
      </form>

      {showPaymentModal && (
        <PaymentModal
          paymentUrl={paymentUrl}
          onSuccess={handlePaymentSuccess}
          onError={handlePaymentError}
          onClose={() => setShowPaymentModal(false)}
        />
      )}

      <ToastContainer position="top-right" autoClose={5000} />
    </div>
  );
}

export default SApp;